module.exports = __webpack_public_path__ + "img/zhaf_05.4b6b7e71.jpg";